import { useEffect, useRef } from "react";
export default function SymbolOverview() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!ref.current) return;
    const s = document.createElement("script");
    s.src = "https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js";
    s.async = true;
    s.innerHTML = JSON.stringify({
      symbols: [
        ["NASDAQ:AAPL","AAPL"],
        ["NASDAQ:MSFT","MSFT"],
        ["NASDAQ:TSLA","TSLA"],
        ["AMEX:SPY","SPY"],
        ["NYSE:VTI","VTI"],
        ["NASDAQ:QQQ","QQQ"],
      ],
      width: "100%",
      height: "400",
      locale: "en",
      colorTheme: "dark",
      autosize: true,
      showVolume: true,
      showMA: true,
      chartType: "area",
    });
    ref.current.appendChild(s);
    return () => ref.current?.replaceChildren();
  }, []);
  return <div className="tradingview-widget-container" ref={ref} />;
}
